import React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import styles from "../../../styles/stylesgenerales";
import validacion from "../../../helpers/validaciones";
import Campanias from "../../Acceso/Campanias/view";
import logo from "../../../images/logoachs.png";
import logoEmail from "../../../images/emailSended.png";
import { Button, TextBox, Validator } from "devextreme-react";
import { paths } from "../../../config/routes";
import RecuperacionPassword from "./RecuperacionPassword";
import StatusCuentaUsuario from "./StatusCuentaUsuario/";
import ActivacionCuentaUsuario from "./ActivacionCuenta/";
import {
  setCodeError,
  resetState,
  doGetUserOptions,
  disableNext,
  doSendCode,
  doValidateCode,
  doChangePassword,
  enableNext,
  validacionIdentidadAction,
  EnvioEmailSMSActivacionCuenta,
  renderBody,
} from "./actions";

import Step1 from "./DatosPersonales/Step1";
import Step2 from "./SendCode/Step2";
import Step3 from "./ValidateCode/step3";
import Step4 from "./NewPass/step4";
import Step5 from "./success";
import LoadingOverlay from "../../Shared/LoadingOverlay";
import ValidacionCuentaUsuario from "./ValidacionCuentaUsuario";
import { statusMessages, validacionUsuarioFlujos } from "./statusMessages";
import { isIframe } from "helpers/isIframe";

const isAbleLoginAv1 = process.env.REACT_APP_IS_ABLE_LOGIN_AV1 === 'true' ? true : false;

class RecuperarPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: "",
      code: "",
      type: null,
      select: "",
      telefonoActivacion: "",
      emailActivacion: "",
      cambio: 0,
    };
    window.location.href = '/achs/recupera-o-activa/ingresa-tu-rut';
  }
  // componentDidMount = () => {
  //   this.props.dispatch(resetState());
  // };

  validateUser = () => {
    const { user, serialCI } = this.state;
    sessionStorage.setItem("serialCIActivacion", serialCI);
    sessionStorage.setItem(
      "rutUsuarioActivacion",
      validacion.formatRut(user, { showDots: false, showHyphen: true })
    );
    this.props.dispatch(validacionIdentidadAction());

    // let user = this.state.user;
    // if (this.state.type === "RUN") {
    //   user = validacion.formatRut(user, { showDots: false, showHyphen: true });
    // }
    // this.props.dispatch(doGetUserOptions(user));
  };

  validateUser = () => {
    const { user, serialCI } = this.state;
    sessionStorage.setItem("serialCIActivacion", serialCI);
    sessionStorage.setItem(
      "rutUsuarioActivacion",
      validacion.formatRut(user, { showDots: false, showHyphen: true })
    );
    this.props.dispatch(validacionIdentidadAction());

    // let user = this.state.user;
    // if (this.state.type === "RUN") {
    //   user = validacion.formatRut(user, { showDots: false, showHyphen: true });
    // }
    // this.props.dispatch(doGetUserOptions(user));
  };

  handleSendCode = () => {
    this.props.dispatch(
      doSendCode(this.state.select, this.props.email, this.props.isTemporal)
    );
  };

  handleValidateCode = () => {
    this.props.dispatch(doValidateCode(this.state.code, this.props.email));
  };

  handleNewPass = (newPassword, passConfirmation) => {
    this.props.dispatch(
      doChangePassword({
        email: this.props.email,
        code: this.state.code,
        isTemporal: this.props.isTemporal,
        pass: newPassword,
        passConfirmation,
      })
    );
  };

  handleFullCode = (fullCode) => {
    if (fullCode) {
      this.props.dispatch(setCodeError(false));
      this.setState({ code: fullCode });
      this.props.dispatch(enableNext());
    } else {
      this.setState({ fullCode: "" });
      this.props.dispatch(disableNext());
    }
  };

  handleChange = (e) => {
    switch (e.element.id) {
      case "user":
        let errorEmailRut = "";
        let isValid = true;
        let validacionTpo = "";
        let value = e.value;

        if (validacion.validateRut(e.value) === false) {
          errorEmailRut = "Formato de rut inválido";
          isValid = false;
        } else if (validacion.validateRut(e.value)) {
          validacionTpo = "RUN";
        }

        if (isValid) this.props.dispatch(enableNext());
        else this.props.dispatch(disableNext());

        if (validacionTpo === "RUN") {
          value = validacion.formatRut(value, {
            showDots: true,
            showHyphen: true,
          });
        }

        this.setState({
          user: value,
          type: validacionTpo,
        });
        e.component.option({
          validationError: { message: errorEmailRut },
          isValid,
        });
        break;
      case "serialCI":
        this.setState({ serialCI: e.value });
      case "rut":
        this.setState({ select: e.value });
        this.props.dispatch(enableNext());
        break;
      case "telefono":
        this.setState({ telefonoActivacion: e.value });
      case "email":
        this.setState({ emailActivacion: e.value });
      default:
        break;
    }
  };

  backToLogin = () => {
    this.props.dispatch(push(paths.root));
  };

  renderBody = () => {
    switch (this.props.step) {
      case 0:
        return (
          <ValidacionCuentaUsuario
            titulo={"Validación de cuenta"}
            dispatch={this.props.dispatch}
          />
        );
      case 1:
        const { email, phone } = this.props;
        return (
          <Step2
            nextStep={this.handleSendCode}
            options={[email, phone]}
            handleChange={this.handleChange}
            disabled={this.props.disableNext}
          />
        );
      case 2:
        return (
          <Step3
            nextStep={this.handleValidateCode}
            codeError={this.props.codeError}
            disabled={this.props.disableNext}
            reSend={this.handleSendCode}
            handleFullCode={this.handleFullCode}
            typeSelected={this.props.typeSelected}
            dispatch={this.props.dispatch}
            emailMasked={this.props.emailMasked}
            phoneMasked={this.props.phoneMasked}
          />
        );
      case 3:
        return (
          <Step4
            nextStep={this.handleNewPass}
            disabled={this.props.disableNext}
          />
        );
      case 4:
        return <Step5 nextStep={this.backToLogin} />;
      case 801:
        return (
          <ActivacionCuentaUsuario
            dispatch={this.props.dispatch}
            message={this.props.message}
            telefonoActivacion={this.state.telefonoActivacion}
            emailActivacion={this.state.emailActivacion}
          />
        );
      case 800:
        return (
          <RecuperacionPassword
            telefono={this.props.phone}
            email={this.props.email}
            titulo={"Restablecimiento de contraseña"}
            descripcion={`Para restablecer tu contraseña ingresa los siguientes datos y recibiras
              un codigo verificador para continuar el proceso`}
            dispatch={this.props.dispatch}
          />
        );
      case 802:
        return (
          <Step1
            disabled={this.props.disableNext}
            handleChange={this.handleChange}
            error={this.props.userInfoError}
            nextStep={this.validateUser}
            value={this.state.user}
            dispatch={this.props.dispatch}
            flujo={validacionUsuarioFlujos.restablecerContraseñaConValidacion}
          />
        );
      default:
        return (
          <StatusCuentaUsuario
            statusCuenta={this.props.statusCuenta}
            dispatch={this.props.dispatch}
            message={this.props.message}
            email={this.props.email}
            phone={this.props.phone}
            emailMasked={this.props.emailMasked}
            phoneMasked={this.props.phoneMasked}
          />
        );
    }
  };

  render() {
    if (
      this.state.telefonoActivacion !== this.props.phone &&
      this.state.emailActivacion !== this.props.email &&
      !this.state.first
    )
      this.setState({
        telefonoActivacion: this.props.phone,
        emailActivacion: this.props.email,
        first: true,
      });
    
      if(!isAbleLoginAv1) return <></>
    return (
      <div
        className="zero row"
        style={{
          justifyContent: "center",
          height: "100%",
          overflowY: "auto",
        }}
      >
        {/* <div
          className="zero d-none d-md-block col-xs-8 col-sm-8 col-md-6 col-lg-7 col-xl-8"
          style={{ backgroundColor: "#004A52", height: "100vh" }}
        >
          <Campanias />
        </div> */}
        <div className="zero col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-4">
          <div className="zero container-fluid" style={{ minWidth: '38em' }}>
            <div className="zero row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div>
            </div>
            <center>
              <div className="zero row">
                <div className="headerLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <img
                    src={logo}
                    alt=""
                    style={styles.logoLogin}
                    height="65px"
                  />
                  <h2 style={{ textAlign: "center", paddingTop: 1 }}>
                    {" "}
                    {/* Restablecer contraseña{" "} */}
                  </h2>
                </div>
              </div>
              {this.props.isLoading && <LoadingOverlay />}

              {this.renderBody()}
            </center>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    step: state.recover.step,
    validationCode: state.recover.validationCode,
    codeError: state.recover.codeError,
    email: state.recover.email,
    emailMasked: state.recover.emailMasked,
    statusCuenta: state.recover.statusCuenta,
    phoneMasked: state.recover.phoneMasked,
    message: state.recover.mensaje,
    isLoading: state.recover.isLoading,
    userInfoError: state.recover.userInfoError,
    isTemporal: state.recover.isTemporal,
    disableNext: state.recover.disableNext,
    typeSelected: state.recover.typeSelected,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RecuperarPassword);
